export default "assets/images/contact-mail-c6a2a433.png";